import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <header className="sf-nav" data-testid="site-navbar">
      <div className="sf-container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 64 }}>
        <Link to="/" data-testid="navbar-logo-link" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
          <img
            src="/systemforge-logo.png"
            alt="SystemForge AI"
            data-testid="navbar-logo-img"
            style={{ height: 36, width: 36, objectFit: "contain" }}
          />
          <span className="sf-display" style={{ fontSize: 18, letterSpacing: "-0.01em" }}>
            SystemForge <span className="sf-gold">AI</span>
          </span>
        </Link>
        <nav style={{ display: "flex", gap: 18, alignItems: "center" }}>
          <Link
            to="/audit"
            data-testid="navbar-run-diagnostic"
            className="sf-btn"
            style={{ fontSize: 14, padding: "8px 16px" }}
          >
            Run Free Diagnostic
          </Link>
        </nav>
      </div>
    </header>
  );
}
